import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import {
  getOutcomeType,
  getDatasetFromSetup,
  getSelectedFields,
  getErrors,
  getIgnored,
  getIgnoredValue,
  getIsForecast,
  getFieldTypes,
  getPriceColumn,
  getValueReplace,
  editValueReplace,
  resetSetup,
  addValueReplace,
  updateOutcome,
  updateFieldTypes,
  updateDatasetId,
  updatePriceColumn,
  updateIgnored,
  updateIgnoredValue,
  updateSelectedFields,
  bulkUpdateIgnoredValues
} from "containers/Setup/reducer";
import { getStep, updateStep } from "containers/CreateWizard/reducer";
import {
  getAllColumnDescription,
  getOriginalDataset,
  updateColumnDescription,
  updateIsSensitive,
  getIsSensitive,
  getIsEditing
} from "containers/Blueprint/reducer";

import * as projectReducer from "containers/Project/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as setupReducer from "containers/Setup/reducer";

import ChooseColumns from "components/CreateWizard/Dataset/ChooseColumns";

class ChooseColumnsContainer extends React.PureComponent {
  render() {
    const { step, index, transformUpdateDataset } = this.props;

    return <ChooseColumns {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateSelection: (selection) => {
    !ownProps.blueprintId && dispatch(resetSetup(ownProps.id));
    return dispatch(updateDatasetId(ownProps.id, selection.value));
  },
  updatePriceColumn: (column) => dispatch(updatePriceColumn(ownProps.id, column)),
  updateOutcome: (outcome) => dispatch(updateOutcome(ownProps.id, outcome)),
  updateStep: (step) => dispatch(updateStep(step)),
  updateIgnored: (column, isIgnored) => dispatch(updateIgnored(ownProps.id, column, isIgnored)),
  updateIsSensitive: (column, isSensitive) => dispatch(updateIsSensitive(ownProps.blueprintId, column, isSensitive)),
  updateSelectedFields: (field) => dispatch(updateSelectedFields(ownProps.id, field)),
  updateIgnoredValue: (column, value, isIgnored) => dispatch(updateIgnoredValue(ownProps.id, column, value, isIgnored)),
  bulkUpdateIgnoredValues: (column, valueList, ignoreAll) =>
    dispatch(updateIgnoredValue(ownProps.id, column, valueList, ignoreAll)),
  updateColumnDescription: (blueprintId, column, description) =>
    dispatch(updateColumnDescription(blueprintId, column, description)),

  updateColumnDescriptionDataset: (datasetId, index, column, description) =>
    dispatch(homeReducer.updateColumnDescription(datasetId, index, column, description)),

  updateFieldTypes: (field, type) => dispatch(updateFieldTypes(ownProps.id, field, type)),

  editValueReplace: (vId, type, data) => dispatch(editValueReplace(ownProps.id, vId, type, data)),

  addValueReplace: (column) => dispatch(addValueReplace(ownProps.id, column))
});

const mapStateToProps = (state, ownProps) => {
  const selectedDataset = getDatasetFromSetup(state, ownProps.id);

  return {
    selectedDataset: selectedDataset,
    selectedFields: getSelectedFields(state, ownProps.id),
    ignored: getIgnored(state, ownProps.id),
    ignoredValue: getIgnoredValue(state, ownProps.id),
    step: getStep(state),
    isContinuous: getOutcomeType(state, ownProps.id) === "number",
    columnDescription: getAllColumnDescription(state, ownProps.blueprintId),
    originalDataset: getOriginalDataset(state, ownProps.blueprintId),
    errors: getErrors(state, ownProps.id),
    priceColumn: getPriceColumn(state, ownProps.id),
    valueReplace: getValueReplace(state, ownProps.id),
    fieldTypes: getFieldTypes(state, ownProps.id),
    sensitive: getIsSensitive(state, ownProps.blueprintId),
    isOverallSegment: projectReducer.getIsOverallSegment(state, ownProps.projectId, ownProps.id),
    isEditing: getIsEditing(state, ownProps.blueprintId, ownProps.id),

    isForecast: setupReducer.getIsForecast(state, ownProps.id),
    forecastTimeCol: setupReducer.getForecastTimeCol(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ChooseColumnsContainer);
